const superfetch = {
  emptyInput: "Este valor no puede estar vacio",
  fileTypes: "Tipos de Archivo:",
  backEdit: "Regresar a Editar",
};

export default superfetch;
